'use client';

import Container from '@mui/material/Container';
import {useTranslation} from 'react-i18next';
import type {DetailPageAnalytics} from '../../analytics';
import {RichContent} from '../article';
import {DownloadBrochureButton} from '../brochure';
import {Section, SectionTitle} from '../primitives';

export interface DetailAboutProps {
  item: {uuid: string; name: string; description?: string; brochureUrl?: string};
  analytics: DetailPageAnalytics;
}

export function DetailAbout({item, analytics}: DetailAboutProps) {
  const {t} = useTranslation();
  if (!item.description && !item.brochureUrl) {
    return null;
  }
  return (
    <Section tone="raised">
      <Container>
        <SectionTitle as="h2" sx={{mb: 1}}>
          {t('about_property')}
        </SectionTitle>
        {item.description && <RichContent html={item.description} />}
        {item.brochureUrl && (
          <DownloadBrochureButton
            url={item.brochureUrl}
            name={item.name}
            onDownload={() => {
              analytics.downloadBrochure({id: item.uuid, name: item.name});
            }}
            sx={{mt: 3}}
          />
        )}
      </Container>
    </Section>
  );
}

DetailAbout.displayName = 'DetailAbout';
